export default function isEventResolved(status: string): boolean {
  return status === 'resolved' || status === 'auto_resolved';
}
